import { render, staticRenderFns } from "./EmailConfirmation.vue?vue&type=template&id=bb8614a2&scoped=true&"
import script from "./EmailConfirmation.vue?vue&type=script&lang=js&"
export * from "./EmailConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./EmailConfirmation.vue?vue&type=style&index=0&id=bb8614a2&scoped=true&lang=scss&"
import style1 from "./EmailConfirmation.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8614a2",
  null
  
)

export default component.exports